import { router } from '@leprecoins/effector';
import { ActionIcon, Title } from '@mantine/core';
import { useUnit } from 'effector-react';
import { ChevronLeft } from 'lucide-react';
import { cashdeskPageModel } from 'pages/cashdesk-page/model';
import { useBreakpoint } from 'shared/lib';
import cls from './cashdesk-page-heading.module.scss';

export const CashdeskPageHeading = () => {
	const [cashdesk, back] = useUnit([cashdeskPageModel.$cashdesk, router.back]);

	const md = useBreakpoint('md');

	return (
		cashdesk !== null && (
			<div className={cls.cashdeskPageHeading}>
				<ActionIcon
					variant='outline'
					onClick={back}
				>
					<ChevronLeft />
				</ActionIcon>
				<Title
					order={1}
					size={md ? 'h1' : 'h3'}
					className={cls.cashdeskPageHeadingTitle}
				>
					{cashdesk?.name}
				</Title>
			</div>
		)
	);
};
